var render, staticRenderFns
import script from "./RingProductSettings.vue?vue&type=script&lang=js&"
export * from "./RingProductSettings.vue?vue&type=script&lang=js&"
import style0 from "./RingProductSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src414009122/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e411f15')) {
      api.createRecord('1e411f15', component.options)
    } else {
      api.reload('1e411f15', component.options)
    }
    
  }
}
component.options.__file = "src/containers/Customer/Devices/Settings/RingProductSettings.vue"
export default component.exports